import KYCComponent from './KYCComponent';

export default KYCComponent;
